<div class="container">
  <div>
    <mat-form-field
      appearance="outline"
      [style.width.%]="100"
      *ngIf="data.crimeChargedWith || data.isCourtClearanceRequired"
    >
      <mat-label>Input Court Clearance Number</mat-label>
      <input
        matInput
        appCharactersOnly
        appNoLeadingSpaces
        placeholder="Search"
        [formControl]="courtClearanceNumber"
      />
      <mat-error *ngIf="courtClearanceNumber.errors?.required"
        >Court Clearance Number is Required</mat-error
      >
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Choose Police Clearance</mat-label>
      <mat-select [formControl]="policeClearance">
        <mat-option value="1"> Local </mat-option>
        <mat-option value="2"> National </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      [style.width.%]="100"
      *ngIf="policeClearance.value"
    >
      <mat-label>Input Police Clearance Number</mat-label>
      <input
        matInput
        appCharactersOnly
        appNoLeadingSpaces
        [formControl]="policeClearanceNumber"
      />
    </mat-form-field>
    <ngx-dropzone
      (change)="onSelect($event)"
      [multiple]="false"
      accept="image/*,application/pdf"
      class="mt-3"
    >
      <ngx-dropzone-label>Click here to upload file! </ngx-dropzone-label>
      <ngx-dropzone-preview
        *ngFor="let f of files"
        [removable]="true"
        (removed)="onRemove(f)"
      >
        <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
      </ngx-dropzone-preview>
    </ngx-dropzone>
  </div>
  <div class="mt-3">
    <button
      mat-raised-button
      color="primary"
      (click)="forBcpoProcessing()"
      [disabled]="isLoading"
    >
      {{ isLoading == true ? "Submitting" : "Submit" }}
    </button>
  </div>
</div>
